(() => {
  const root = () => window.Shopify?.routes?.root || document.body.dataset.vrRoot || '/';
  let cartTrigger;
  let cartRequest;
  async function loadBag(open = false) {
    if (cartRequest) await cartRequest;
    const previous = document.getElementById('vueraith-bag');
    const wasOpen = previous?.open;
    cartRequest = (async () => {
      const response = await fetch(root() + 'cart?section_id=vueraith-mini-cart', {headers: {'Accept': 'text/html'}});
      if (!response.ok) throw new Error('bag');
      const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const dialog = fragment.getElementById('vueraith-bag');
      if (!dialog) throw new Error('bag');
      previous?.close();
      previous?.replaceWith(dialog);
      if (wasOpen || open) dialog.showModal();
      const count = dialog.querySelector('#vr-bag-title small')?.textContent;
      if (count) document.querySelectorAll('.bag span').forEach(span => {span.textContent = count; span.setAttribute('aria-label', count.replace(/[()]/g, '') + ' items');});
      dialog.addEventListener('close', () => cartTrigger?.focus(), {once: true});
    })();
    try {await cartRequest;} finally {cartRequest = null;}
  }
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-vr-close]');
    if (close) {close.closest('dialog')?.close(); return;}
    const opener = event.target.closest('[data-vr-open-cart]');
    if (opener && document.getElementById('vueraith-bag') && typeof HTMLDialogElement !== 'undefined') {
      event.preventDefault(); cartTrigger = opener;
      const dialog = document.getElementById('vueraith-bag');
      if (!dialog.open) dialog.showModal();
      dialog.addEventListener('close', () => cartTrigger?.focus(), {once:true});
      try {await loadBag(true);} catch (_) {window.location.assign(opener.href);}
      return;
    }
    const remove = event.target.closest('[data-vr-remove-key]');
    if (remove) await changeLine(remove.dataset.vrRemoveKey, 0);
    const zoom = event.target.closest('[data-vr-zoom]');
    if (zoom) {
      const gallery = zoom.closest('.pdp-media');
      const image = gallery.querySelector('[data-vv-slide]:not([hidden]) img');
      const dialog = gallery.querySelector('[data-vr-zoom-dialog]');
      if (image && dialog) {
        const large = dialog.querySelector('img');
        const source = new URL(image.currentSrc || image.src, location.href);
        source.searchParams.set('width', '2400');
        large.src = source.href; large.alt = image.alt;
        dialog.showModal();dialog.addEventListener('close', () => zoom.focus(), {once:true});
      }
    }
    const carouselButton = event.target.closest('[data-vr-carousel-back], [data-vr-carousel-next]');
    if (carouselButton) {
      const track = carouselButton.closest('[data-vr-related]').querySelector('[data-vr-related-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('article'));
      const origin = track.getBoundingClientRect().left;
      const positions = cards.map(card => card.getBoundingClientRect().left - origin + track.scrollLeft);
      const backwards = carouselButton.hasAttribute('data-vr-carousel-back');
      const target = backwards
        ? positions.filter(position => position < track.scrollLeft - 2).pop() ?? 0
        : positions.find(position => position > track.scrollLeft + 2) ?? track.scrollWidth;
      track.scrollTo({left: target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
  let changing = false;
  async function changeLine(key, quantity) {
    const dialog = document.getElementById('vueraith-bag');
    if (changing || !dialog || !Number.isInteger(quantity) || quantity < 0 || quantity > 99) return;
    changing = true;dialog.setAttribute('aria-busy','true');
    try {
      const response = await fetch(root() + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      if (!response.ok) throw new Error('quantity');
      await loadBag(true);
    } catch (_) {
      const feedback=dialog.querySelector('.vr-bag-feedback');
      if (feedback) feedback.textContent=document.documentElement.lang.startsWith('en') ? 'Your bag could not be updated. Please try again.' : 'Please try again.';
    } finally {changing=false;dialog.removeAttribute('aria-busy');}
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-vr-line-key]')) changeLine(event.target.dataset.vrLineKey, Number(event.target.value));
  });
  document.addEventListener('vueraith:cart-added', () => {
    cartTrigger=document.querySelector('[data-pdp-buy]');
    loadBag(true).catch(() => window.location.assign(root()+'cart'));
  });
  let filterRequest;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-vr-filter-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const section=form.closest('[data-vr-collection]');
    const url=new URL(form.action,location.origin);
    for (const [key,value] of new FormData(form)) if (value!=='') url.searchParams.append(key,value);
    const fetchUrl=new URL(url);fetchUrl.searchParams.set('section_id',section.dataset.sectionId);
    filterRequest?.abort();filterRequest=new AbortController();
    section.setAttribute('aria-busy','true');
    try {
      const response=await fetch(fetchUrl,{signal:filterRequest.signal});
      if (!response.ok) throw new Error('filters');
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=parsed.querySelector('[data-vr-collection]');
      if (!next) throw new Error('filters');
      section.replaceWith(next);history.pushState({},'',url);
      const target=next.querySelector('.vr-collection__grid') || next.querySelector('h1');
      target?.setAttribute('tabindex','-1');target?.focus();
    } catch(error) {if (error.name!=='AbortError') location.assign(url.href);} finally {section.removeAttribute('aria-busy');}
  });
  window.addEventListener('popstate',()=>{if(document.querySelector('[data-vr-collection]')) location.reload();});
  function enhance(scope=document) {
    scope.querySelectorAll('[data-vr-related]').forEach(section=>{
      if(section.dataset.loaded || !section.dataset.productId) return;
      section.dataset.loaded='true';
      const load=async()=>{
        const url=new URL(root()+'recommendations/products',location.origin);
        url.search=new URLSearchParams({section_id:section.dataset.sectionId,product_id:section.dataset.productId,limit:'6',intent:'related'});
        try {const response=await fetch(url);if(!response.ok) return;const parsed=new DOMParser().parseFromString(await response.text(),'text/html');const result=parsed.querySelector('[data-vr-related]');if(result?.querySelector('article')) section.replaceWith(result);else section.hidden=true;}catch(_){section.hidden=true;}
      };
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'350px'});observer.observe(section);}else load();
    });
    scope.querySelectorAll('[data-vr-model]').forEach(details=>details.addEventListener('toggle',()=>{if(details.open && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:()=>{const model=details.querySelector('model-viewer');if(model && window.Shopify.ModelViewerUI && !details.dataset.ready){new window.Shopify.ModelViewerUI(model);details.dataset.ready='true';}}}]);}));
  }
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('vr-reveal');reveal.unobserve(entry.target);}}),{threshold:.12});
    document.querySelectorAll('.vr-v4-discovery__story,.vr-v5-lenses__visual,.vr-v5-studio').forEach(element=>reveal.observe(element));
  }
  enhance();document.addEventListener('shopify:section:load',event=>enhance(event.target));
})();
